import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from 'src/shared/components/button';
import { BREAKPOINTS, useLayout } from 'src/shared/hooks/useLayout';
const BulkActionButton = ({ loading, disabled, ...props }) => {
    const { screenWidth } = useLayout();
    return (_jsx(Button, { className: "flex-[0_0_calc(50%-2px)] md:flex-initial", variation: screenWidth <= BREAKPOINTS.md ? 'secondary' : 'tertiary', loading: loading, disabled: loading || disabled, ...props }));
};
export default BulkActionButton;
